import { render, staticRenderFns } from "./text-meta-count.vue?vue&type=template&id=052fe676&"
import script from "./text-meta-count.vue?vue&type=script&lang=js&"
export * from "./text-meta-count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports